<template>
    <div class="table-responsive">
        <table
            id="variables-datatable"
            class="table table-centered table-striped table-bordered my-2"
        >
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Relative form field</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="variable in variables" :key="variable.code">
                    <td>{{ variable.formValue }}</td>
                    <td>{{ variable.formLabel }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        variables: {
            type: Array,
            required: false,
            default: () => []
        }
    }
};
</script>
